// extracted by mini-css-extract-plugin
module.exports = {"faqConatiner":"faqs_faqConatiner__25msy","head":"faqs_head__XBjKX","list":"faqs_list__3E32j","faq":"faqs_faq__3-aXg","ques":"faqs_ques__d2IUR"};